import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiMenu, FiX, FiPhone } from "react-icons/fi";
import logo from "../assets/melona logo.png";

const PremiumHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`premium-header${scrolled ? " scrolled" : ""}`}>
      <div className="premium-header__content">
        <Link to="/" className="premium-header__logo">
          <img src={logo} alt="Melona" style={{ height: "40px", width: "auto" }} />
        </Link>

        <nav className="premium-header__nav">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/gallery">Portfolio</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <NavLink to="/login">Login</NavLink>
        </nav>

        <div className="premium-header__cta">
          <Link to="/contact" className="btn-premium-primary" style={{ padding: "0.75rem 1.5rem" }}>
            <FiPhone /> Get Quote
          </Link>
        </div>

        <button
          className="premium-header__mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="premium-mobile-menu">
          <nav className="premium-mobile-nav">
            <NavLink to="/" end onClick={() => setMobileMenuOpen(false)}>Home</NavLink>
            <NavLink to="/about" onClick={() => setMobileMenuOpen(false)}>About</NavLink>
            <NavLink to="/services" onClick={() => setMobileMenuOpen(false)}>Services</NavLink>
            <NavLink to="/gallery" onClick={() => setMobileMenuOpen(false)}>Portfolio</NavLink>
            <NavLink to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact</NavLink>
            <NavLink to="/login" onClick={() => setMobileMenuOpen(false)}>Login</NavLink>
          </nav>
          <Link 
            to="/contact" 
            className="btn-premium-primary" 
            style={{ width: "100%", justifyContent: "center", marginTop: "var(--sp-4)" }}
            onClick={() => setMobileMenuOpen(false)}
          >
            <FiPhone /> Get Free Quote
          </Link>
        </div>
      )}
    </header>
  );
};

export default PremiumHeader;
